import type { AppEnvironment } from './types';

/**
 * Hire24 vertical. Bundle-id `com.sudosky.hire24.member`, public hostname
 * `app.hire24.co.za`. Reuses Core API for SSO; regional API URL is filled
 * in at runtime when the user picks a community / via domain resolution.
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'hire24',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  appTemplateId: '',
  authMode: 'core',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: 'app.hire24.co.za',
  rootTenantId: '',
  portalBaseUrl: 'https://app.hire24.co.za',
  appName: 'Hire24 Member',
  version: '1.0.0',
  appShell: 'classic',
};
